import React from 'react';
import { FormControl, InputLabel, Select } from '@mui/material';
import { IMetric, allMetrics } from '../../subpages/AgentStatus';

export const AgentMetricDropdown = (props: {
  onSetMetric: ({ title, key }) => void;
  metric: IMetric;
}) => {
  function metricHandler(e) {
    const [title, key] = e.target.value.split(',');
    props.onSetMetric({ title: title, key: key });
  }
  const groupTypes = ['Status', 'Call Metrics'];
  const defaults = [
    {
      ...allMetrics.totalCallHandleTime,
      groups: ['Status'],
    },
    {
      ...allMetrics.loggedInTime,
      groups: ['Status'],
    },
    {
      ...allMetrics.idleTime,
      groups: ['Status'],
    },
    {
      ...allMetrics.dndTime,
      groups: ['Status'],
    },
    {
      ...allMetrics.callsHandled,
      groups: ['Call Metrics'],
    },
    {
      ...allMetrics.avgCallHandleTime,
      groups: ['Call Metrics'],
    },
    {
      ...allMetrics.speedToAnswerAvgTime,
      groups: ['Call Metrics'],
    },
    {
      ...allMetrics.callHandleAvgTime,
      groups: ['Call Metrics'],
    },
    {
      ...allMetrics.acwAvgTime,
      groups: ['Call Metrics'],
    },
  ];

  return (
    <FormControl
      style={{
        marginLeft: '1vw',
        marginTop: '10px',
      }}
      size="small"
      variant="outlined"
    >
      <InputLabel>Metric</InputLabel>
      <Select
        defaultValue={`${props?.metric?.title},${props?.metric?.key}`}
        native
        onChange={metricHandler}
        label="Metric"
        name="metric-dropdown"
      >
        {groupTypes.map((group) => (
          <optgroup key={group} label={group}>
            {defaults
              .filter((metric) => metric.groups.includes(group))
              .map((metric) => (
                <option
                  key={metric.key}
                  value={`${metric?.title},${metric?.key}`}
                >
                  {metric?.title}
                </option>
              ))}
          </optgroup>
        ))}
      </Select>
    </FormControl>
  );
};

export default AgentMetricDropdown;
